'use client';

import { IProductDetail } from '@/api/types/public';
import { font } from '@/theme/zeelool.theme';
import { Box, Typography } from '@mui/material';

interface ProductDescriptionProps {
  detail?: IProductDetail;
}

export default function ProductDescription({ detail }: ProductDescriptionProps) {
  if (!detail?.show_description) {
    return null;
  }

  return (
    <Box
      className="bg-auxiliary-gray p-16 flex justify-center items-center"
      sx={{
        borderRadius: '4px',
      }}
    >
      <Box className="w-full">
        <Typography
          component="div"
          className="mt-4 text-[14px]leading-[22px] text-left font-normal break-words"
          dangerouslySetInnerHTML={{ __html: detail.show_description || '' }}
          sx={{
            fontFamily: font.ir,
            '& h1, & h2, & h3': {
              fontFamily: font.bb,
              fontSize: '20px',
              lineHeight: '24px',
              marginBottom: 2,
            },
            '& p': {
              marginBottom: '12px',
            },
            '& p:last-child': {
              marginBottom: 0,
            },
            '& a': {
              color: '#463AE8',
              textDecoration: 'underline',
            },
            '& img': {
              maxWidth: '100%',
              height: 'auto',
              // margin: '16px 0',
            },
            '& ul, & ol': {
              paddingLeft: '20px',
              marginBottom: 2,
            },
            '& li': {
              marginBottom: 1,
            },
          }}
        />
      </Box>
    </Box>
  );
}
